import { PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';
import { AbstractTuiDialogService } from '@taiga-ui/cdk';
import { Injectable } from '@angular/core';

import { DrawerOptions } from './drawer.config';
import { DrawerContainerComponent } from './drawer-container.component';
import { DrawerCloseService } from './drawer-close.service';

@Injectable({ providedIn: 'root' })
export class DrawerService<T> extends AbstractTuiDialogService<DrawerOptions<T>> {
  protected readonly component = new PolymorpheusComponent(DrawerContainerComponent);
  protected readonly defaultOptions = {
    data: undefined as T,
    closeService: new DrawerCloseService(),
  };
}
